export default __webpack_public_path__ + "assets/fonts/NotoSansRegular.woff2";